const capitalizeFirstLetter = (word: string) => {
  const capitalizedText = word.charAt(0).toUpperCase() + word.slice(1);
  return capitalizedText;
};

export default capitalizeFirstLetter;
